export const zendeskConfig = {
  url: window["env"]["zendeskUrl"] || ""
};
